/**
 * Auth token storage only. Compatible with getSignature and dashboard.
 * Login, register, sponsor/username checks use useAxiosHelper + ApiPaths (Config/ApiPath.js).
 */
export const authApi = {
  getToken() {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem('token');
  },

  setToken(token) {
    if (typeof window === 'undefined') return;
    localStorage.setItem('token', token);
  },

  removeToken() {
    if (typeof window === 'undefined') return;
    localStorage.removeItem('token');
  },
};
